var utils = require( './utils' );

var our_process_nav = ( function( $ ) {

	var $nav,
		setup = false;

	var _init = function() {
		$nav = $( '#page-scroll-nav' );

		if ( utils.viewport_size().width >= 1200 ) {
			_setup_links();
		}

		setup = true;
	};

	var _setup_links = function() {
		var $links = $nav.find( 'a.nav-link' );

		$links.each( function( index, item ) {
			_setup_link( $( item ) );
		} );
	};

	var _setup_link = function( $link ) {
		_maybe_update_link_class( $link );

		$( window ).on( 'scroll', function() {
			_maybe_update_link_class( $link );
		} );
	};

	var _maybe_update_link_class = function( $link ) {
		if ( _target_in_view( $link ) ) {
			$link.addClass( 'target-in-view' );
		} else {
			$link.removeClass( 'target-in-view' );
		}
	};

	var _target_in_view = function( $link ) {
		var target_id = $link.attr( 'href' ),
			$target   = $( target_id );

		return is_in_view( $target, 100 );
	};

	var is_in_view = function ( $elem, offset ) {
		if ( ! offset ) {
			offset = 0
		}

		var element_top    = $elem.offset().top - offset,
			element_bottom = element_top + $elem.outerHeight() - offset,
			viewport_top = $( window ).scrollTop() - offset,
			viewport_bottom = viewport_top + $( window ).height() - offset;

		return element_bottom > viewport_top && element_top < viewport_bottom
	};

	var show_nav = function( anim_time ) {
		if ( setup ) {
			$nav.fadeIn( anim_time );
			$nav.addClass( 'shown' );
		}
	};

	var hide_nav = function( anim_time ) {
		if ( setup ) {
			$nav.fadeOut( anim_time );
			$nav.removeClass( 'shown' );
		}
	};

	if ( $( '#page-scroll-nav' ).length > 0 ) {
		$( document ).ready( _init );
	}

	return {
		hide_nav: hide_nav,
		show_nav: show_nav
	}

} )( jQuery );

module.exports = our_process_nav;